import py from "pinyin"
import { DEFACULT_VUE_IMG } from "../../constant/system";
export default class UserInfo {
    uid = '';
    name = '';
    displayName = '';
    gender = 0;
    portrait = '';
    mobile = '';
    email = '';
    address = '';
    social = '';
    extra = '';
    type = 0; //0 normal; 1 robot; 2 thing;
    updateDt = 1550652404513;
    firstLetter = '';

    static convert2UserInfo(jsonObj) {
        let userInfo = new UserInfo();
        userInfo.uid = jsonObj.uid;
        userInfo.name = jsonObj.name;
        userInfo.mobile = jsonObj.mobile;
        var showDisplayName = jsonObj.displayName ==='' ? jsonObj.mobile : jsonObj.displayName;
        userInfo.displayName = showDisplayName;
        userInfo.gender = jsonObj.gender;
        var showPortrait = DEFACULT_VUE_IMG;
        if(jsonObj.portrait){
            showPortrait = jsonObj.portrait;
        }
        userInfo.portrait = showPortrait;
        userInfo.email = jsonObj.email;
        userInfo.address = jsonObj.address;
        userInfo.social = jsonObj.social;
        userInfo.extra = jsonObj.extra;
        userInfo.type = jsonObj.type;
        userInfo.updateDt = jsonObj.updateDt;
        userInfo.firstLetter = this.getFristLetter(userInfo.displayName,userInfo.mobile);
        return userInfo;
    }

    static getFristLetter(displayName, mobile) {
        var displayNameForLetter = displayName ==='' ? mobile : displayName;
        var pinyinInitial = py(displayNameForLetter, {
            style: py.STYLE_FIRST_LETTER
        });
        var initial = pinyinInitial[0][0];

        if (initial.length > 1) {
            var initial = initial.substr(0, 1);
            var reg = /^[A-Za-z]/;
            if (reg.test(initial)) {
                initial = initial.toUpperCase();
            } else {
                initial = "#";
            }
        } else {
            initial = initial.toUpperCase();
        }
        return initial;
    }
}


// WEBPACK FOOTER //
// ./src/fscommon/websocket/model/userInfo.js